import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_ellipse.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_o_arrow_right.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron_circle.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-10942e5c")

_pushScopeId("data-v-10942e5c")
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: " text-gray-lp-600 text-xs mb-2" }, "STT/shipment id terakhir", -1)
const _hoisted_3 = {
  ref: "cardContainer",
  class: "w-full flex flex-row space-x-2 overflow-hidden scroll-smooth"
}
const _hoisted_4 = { class: "flex flex-row gap-2 mb-2" }
const _hoisted_5 = { class: "text-gray-lp-300 text-xs font-semibold" }
const _hoisted_6 = { class: " w-auto h-auto whitespace-nowrap text-gray-lp-300 text-10px font-semibold bg-gray-lp-200 text-center rounded-2xl px-2 py-0.5" }
const _hoisted_7 = { class: "flex flex-row items-center space-x-2" }
const _hoisted_8 = { class: "text-gray-lp-800 text-xs font-medium" }
const _hoisted_9 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: " w-1 h-1 block m-auto",
  alt: "icon-ellipse"
}, null, -1)
const _hoisted_10 = { class: "text-gray-lp-800 text-xs font-medium " }
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4 h-4 block m-auto",
  alt: "arrow-right"
}, null, -1)
const _hoisted_12 = { class: "text-gray-lp-800 text-xs font-medium " }
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "next",
  width: "50",
  height: "50"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  style: {"transform":"rotate(180deg)"},
  src: _imports_2,
  alt: "prev",
  width: "50",
  height: "50"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataSTT, (item, index) => {
        return (_openBlock(), _createBlock("div", { key: index }, [
          _createVNode("div", {
            class: "inline-block border rounded-md p-2 border-gray-lp-1400 bg-white cursor-pointer",
            onClick: () => _ctx.onSelectStt(item)
          }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("p", _hoisted_5, _toDisplayString(item.sttNo), 1),
              _createVNode("div", _hoisted_6, _toDisplayString(item.lastStatus), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("p", _hoisted_8, _toDisplayString(item.senderName.split(' ')[0]), 1),
              _hoisted_9,
              _createVNode("p", _hoisted_10, _toDisplayString(item.originCity), 1),
              _hoisted_11,
              _createVNode("p", _hoisted_12, _toDisplayString(item.destinationCity), 1)
            ])
          ], 8, ["onClick"])
        ]))
      }), 128))
    ], 512),
    (_ctx.showRightButton)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "cursor-pointer absolute right-0 z-20",
          style: {"top":"40%"},
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollRight(true)))
        }, [
          _hoisted_13
        ]))
      : _createCommentVNode("", true),
    (_ctx.showLeftButton)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          class: "cursor-pointer absolute left-0 z-20",
          style: {"top":"36%"},
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollRight(false)))
        }, [
          _hoisted_14
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _ctx.dataSTT.length > 0]
  ])
})